import FeatureIcon, {
  type FeatureIconProps
} from '@nespresso/catalog-components-react/controls/FeatureIcon';
import type { Product } from '@/domain/Product';
import styles from './AromaticNotes.module.scss';
import type { PropertySpecification } from '@/domain/Specification';
import useTranslations from '@/widgets/hooks/useTranslations';
import type { Translations } from '@/widgets/ProductList/config';

export interface AromaticNotesProps {
  product: Product;
}

export default function AromaticNotes({ product }: AromaticNotesProps) {
  const { t } = useTranslations<Translations>();
  const aromatics = (product.specifications.aromatics ??
    []) as PropertySpecification[];

  if (aromatics.every((a) => !a.icon)) {
    return null;
  }

  const featureIcons: FeatureIconProps['icons'] = aromatics
    .map((aromatic) => ({
      icon: aromatic.icon ?? '',
      label: aromatic.title
    }))
    .filter((aromatic) => aromatic.icon !== '');
  return (
    <section class={styles.container}>
      <h2 class={styles.heading}>
        {t('productList.quickView.aromaticNotesHeading')}
      </h2>
      <FeatureIcon icons={[...featureIcons]} className={styles.featureIcons} />
    </section>
  );
}
